import React, { useMemo } from 'react';
import { Pane, Table, Tag, Text } from '@ui';
import { gateKeyPath, gateResultTag, gateValueTag, t } from './labels';
import { GATE_KEYS } from './types';
function StepLabel({ step, gate }) {
    return (React.createElement("span", { className: "push-gates__th" },
        React.createElement("span", null,
            React.createElement(Text, { variant: "xx-small", className: "push-gates__step" }, step),
            React.createElement(Text, { variant: "label" }, t(`gates.columns.${gateKeyPath(gate)}`))),
        React.createElement(Text, { variant: "xx-small", className: "push-history__muted" }, t(`gates.stores.${gateKeyPath(gate)}`))));
}
function ResultCell({ row }) {
    const tag = gateResultTag(row);
    return (React.createElement("span", { className: "push-gates__result" },
        React.createElement(Tag, { label: tag.label, variant: tag.variant, colorStyle: "pastry", readOnly: true }),
        row.result === 'sends' && (React.createElement(Text, { variant: "xx-small", className: "push-history__muted" }, t('gates.results.sends_qualifier')))));
}
/** "Would a push reach them right now?" — every server-visible switch, in the order a push meets it. No write path. */
export function PushGatesCard({ technicianName, gates }) {
    const columns = useMemo(() => [
        {
            dataKey: 'label',
            label: t('gates.columns.type'),
            width: '24rem',
            renderer: ({ item }) => React.createElement(Text, null, item.label)
        },
        ...GATE_KEYS.map((gate, index) => ({
            dataKey: gate,
            label: React.createElement(StepLabel, { step: index + 1, gate: gate }),
            renderer: ({ item }) => {
                const tag = gateValueTag(gate, item.gates[gate]);
                return React.createElement(Tag, { label: tag.label, variant: tag.variant, colorStyle: "pastry", readOnly: true });
            }
        })),
        {
            dataKey: 'phone',
            label: React.createElement(StepLabel, { step: GATE_KEYS.length + 1, gate: "phone" }),
            renderer: () => (React.createElement(Text, { variant: "xx-small", className: "push-history__muted" }, t('gates.values.phone')))
        },
        { dataKey: 'result', label: t('gates.columns.result'), renderer: ({ item }) => React.createElement(ResultCell, { row: item }) }
    ], []);
    return (React.createElement(Pane, { className: "push-gates", title: t('gates.title', { name: technicianName }), subtitle: t('gates.hint'), headerRight: React.createElement(Tag, { label: t('gates.read_only'), variant: "gray", colorStyle: "pastry", icon: "fa-light fa-lock", readOnly: true }), footer: React.createElement(Text, { variant: "xx-small", as: "p", className: "push-history__muted" }, t('gates.footer')) },
        React.createElement("div", { className: "push-gates__table" },
            React.createElement(Table, { data: gates, columns: columns, getItemId: (row) => row.type }))));
}
